// Phase 17 — operator admin (list + create) schemas.
//
// Convention 06 — one file per resource concern. The `/admin/operators`
// surface for provisioning additional operator accounts (list existing +
// create a new one, which fires a magic-link sign-in). Distinct from the
// `/me/operator/*` self-service shapes.
import { z } from 'zod';
/** Create-operator request. Email normalised to lowercase (matches the
 *  User.email unique-index normalisation the rest of auth uses). */
export const CreateOperatorRequestSchema = z.object({
    email: z.string().email().toLowerCase(),
    displayName: z.string().trim().min(1).max(120),
});
/** One operator row in the admin list. */
export const OperatorListItemSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    displayName: z.string().nullable(),
    status: z.string(),
    /** Whether the operator has completed TOTP enrollment (they must before
     *  the admin app lets them past /setup-2fa). */
    totpEnrolled: z.boolean(),
    createdAt: z.string(),
});
export const OperatorListResponseSchema = z.object({
    items: z.array(OperatorListItemSchema),
});
/** Create-operator response — the new row + confirmation that the
 *  magic-link sign-in email was dispatched. */
export const CreateOperatorResponseSchema = z.object({
    operator: OperatorListItemSchema,
    magicLinkSent: z.boolean(),
});
/** Deactivate-operator response — revokes the OPERATOR role + cuts sessions. */
export const DeactivateOperatorResponseSchema = z.object({
    success: z.literal(true),
});
/** RC3 (2026-09-02) — reset-operator-TOTP response. Clears TOTP + cuts sessions
 *  so the target re-enrols at /setup-2fa on next sign-in. */
export const ResetOperatorTotpResponseSchema = z.object({
    success: z.literal(true),
});
/** RC3 (2026-09-02) — clear-throttle response. Clears the sign-in / magic-link /
 *  password-reset budget for a locked-out account. */
export const ClearThrottleResponseSchema = z.object({
    success: z.literal(true),
    purposesCleared: z.array(z.string()),
});
//# sourceMappingURL=admin.schema.js.map